import { MaterialUICore, axiomTokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing } = axiomTokens;

export const Div = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: spacing[8],
  rowGap: spacing[6],
});
